import en from 'lang/en.json';
import es from 'lang/es.json';
import fr from 'lang/fr.json';
import it from 'lang/it.json';
import id from 'lang/id.json';
import vi from 'lang/vn.json';
import ch from 'lang/ch.json';
import tw from 'lang/tw.json';
import ja from 'lang/ja.json';
import ko from 'lang/ko.json';
import mn from 'lang/mn.json';
import pt from 'lang/pt-BR.json';
import ru from 'lang/ru.json';
import { localStorage as localStorageConstants } from 'constants/index';
export const messages = {
    en,
    es,
    fr,
    it,
    id,
    vi,
    ch,
    tw,
    ja,
    ko,
    mn,
    pt,
    ru,
};
// ISO 639-1によって、中国語の言語コードはzhです。
// zh-Hant-* = 繁体
// zh-Hans-* = 簡体
const assignChinese = (languageCode) => {
    const traditionalRegex = /((zh-Hant)|(zh-TW))/;
    const simplifiedRegex = /zh-Hans/;
    if (languageCode.match(traditionalRegex)) {
        return 'tw';
    }
    else if (languageCode.match(simplifiedRegex)) {
        return 'ch';
    }
    else {
        return 'ch';
    }
};
const detectLanguage = () => {
    const languageCode = navigator.language;
    if (languageCode.match(/zh/)) {
        return assignChinese(languageCode);
    }
    const replaceRegex = /-/g;
    const formattedCode = languageCode.replace(replaceRegex, '_');
    if (formattedCode in messages) {
        return formattedCode;
    }
    else {
        const languageFamily = formattedCode.split(/[-_]/)[0];
        if (languageFamily in messages) {
            return languageFamily;
        }
        else {
            return 'en';
        }
    }
};
const localeKey = Object.keys(messages);
const navLocale = detectLanguage();
const languageCode = navLocale || 'en';
const defaultLanguage = localStorage.getItem(localStorageConstants.DISPLAY_LANGUAGE);
export const browserLocale = defaultLanguage ||
    (localeKey.includes(languageCode) ? languageCode : 'en');
